import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const authRoutes: Routes = [

  { path: 'auth/login',           loadChildren: () => import('./login/login.module').then(m => m.LoginPageModule) },
  { path: 'auth/signup',          loadChildren: () => import('./signup/signup.module').then(m => m.SignupPageModule) },
  { path: 'auth/activation',      loadChildren: () => import('./activation/activation.module').then(m => m.ActivationPageModule) },
  { path: 'auth/forgot-password', loadChildren: () => import('./forgot-password/forgot-password.module').then(m => m.ForgotPasswordPageModule) },
  { path: 'auth/change-password', loadChildren: () => import('./change-password/change-password.module').then(m => m.ChangePasswordPageModule) }

];

@NgModule({
  imports: [RouterModule.forRoot(authRoutes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AuthRoutingModule { }
